module.exports = __webpack_public_path__ + "img/wrapbg9.98fd95df.png";